import { map } from "lodash";

export const GET_BOOKING_TEMPLATES = "GET_BOOKING_TEMPLATES";
export const GET_BOOKING_TEMPLATE = "GET_BOOKING_TEMPLATE";
export const GET_COMPLIANCE_CHECKS = "GET_COMPLIANCE_CHECKS";
export const GET_LOCATIONS = "GET_LOCATIONS";
export const GET_REASONS_FOR_HIRE = "GET_REASONS_FOR_HIRE";
export const GET_COST_CODES = "GET_COST_CODES";
export const GET_IS_FETCHING_DATA = "GET_IS_FETCHING_DATA";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_IS_FETCHING_FIELD_NECESSITIES =
  "GET_IS_FETCHING_FIELD_NECESSITIES";
export const GET_FIELD_NECESSITIES = "GET_FIELD_NECESSITIES";
export const GET_PUBLISHING_SCHEDULE_TAGS = "GET_PUBLISHING_SCHEDULE_TAGS";
export const GET_IS_FETCHING_PUBLISHING_SCHEDULE_TAGS =
  "GET_IS_FETCHING_PUBLISHING_SCHEDULE_TAGS";
export const GET_TAGS = "GET_TAGS";
export const GET_IS_FETCHING_TAGS = "GET_IS_FETCHING_TAGS";
export const GET_IS_FETCHING_COST_CATEGORIES =
  "GET_IS_FETCHING_COST_CATEGORIES";
export const GET_COST_CATEGORIES = "GET_COST_CATEGORIES";
export const GET_SEXUAL_ORIENTATIONS = "GET_SEXUAL_ORIENTATIONS";
export const GET_IS_FETCHING_SEXUAL_ORIENTATIONS =
  "GET_IS_FETCHING_SEXUAL_ORIENTATIONS";
export const GET_IS_FETCHING_RELIGIONS = "GET_IS_FETCHING_RELIGIONS";
export const GET_RELIGIONS = "GET_RELIGIONS";
export const GET_MARITAL_STATUSES = "GET_MARITAL_STATUSES";
export const GET_IS_FETCHING_MARITAL_STATUSES =
  "GET_IS_FETCHING_MARITAL_STATUSES";
export const GET_LOCATION_GROUPINGS = "GET_LOCATION_GROUPINGS";
export const GET_ETHNIC_GROUPS = "GET_ETHNIC_GROUPS";
export const GET_GRADES = "GET_GRADES";
export const GET_IS_FETCHING_GRADES = "GET_IS_FETCHING_GRADES";
export const GET_WORKING_HOURS = "GET_WORKING_HOURS";
export const GET_WORKING_HOURS_GROUPINGS = "GET_WORKING_HOURS_GROUPINGS";
export const GET_IS_FETCHING_WORKING_HOURS = "GET_IS_FETCHING_WORKING_HOURS";
export const GET_IS_FETCHING_WORKING_HOURS_GROUPINGS =
  "GET_IS_FETCHING_WORKING_HOURS_GROUPINGS";
export const GET_FUNCTIONS = "GET_FUNCTIONS";
export const GET_IS_FETCHING_FUNCTIONS = "GET_IS_FETCHING_FUNCTIONS";
export const GET_CONTRACT_TYPES = "GET_CONTRACT_TYPES";
export const GET_IS_FETCHING_CONTRACT_TYPES = "GET_IS_FETCHING_CONTRACT_TYPES";
export const GET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS =
  "GET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS";
export const GET_CONTRACT_TYPES_GROUPINGS = "GET_CONTRACT_TYPES_GROUPINGS";

const bookingsGetters = {
  [GET_BOOKING_TEMPLATES]: state => state.bookingTemplates,
  [GET_BOOKING_TEMPLATE]: state => state.currentBookingTemplate,
  [GET_LOCATIONS]: state => state.locations,
  [GET_REASONS_FOR_HIRE]: state => state.reasonsForHire,
  [GET_COMPLIANCE_CHECKS]: state => state.complianceChecks,
  [GET_COST_CODES]: state => state.costCodes,
  [GET_IS_FETCHING_DATA]: state => state.isFetchingData,
  [GET_COUNTRIES]: state => {
    return map(state.countries, country => ({
      ...country,
      label: country.countryName,
      value: country.currencyCode
    }));
  },
  [GET_IS_FETCHING_FIELD_NECESSITIES]: state =>
    state.isFetchingFieldNecessities,
  [GET_FIELD_NECESSITIES]: state => state.fieldNecessities,
  [GET_PUBLISHING_SCHEDULE_TAGS]: state => {
    return map(state.publishingScheduleTags, "name");
  },
  [GET_IS_FETCHING_PUBLISHING_SCHEDULE_TAGS]: state =>
    state.isFetchingPublishingScheduleTags,
  [GET_TAGS]: state => {
    return map(state.tags, "term.name");
  },
  [GET_IS_FETCHING_TAGS]: state => state.isFetchingTags,
  [GET_IS_FETCHING_COST_CATEGORIES]: state => state.isFetchingCostCategories,
  [GET_COST_CATEGORIES]: state => state.costCategories,
  [GET_SEXUAL_ORIENTATIONS]: state => state.sexualOrientations,
  [GET_IS_FETCHING_SEXUAL_ORIENTATIONS]: state =>
    state.isFetchingSexualOrientations,
  [GET_RELIGIONS]: state => state.religions,
  [GET_IS_FETCHING_RELIGIONS]: state => state.isFetchingReligions,
  [GET_MARITAL_STATUSES]: state => state.maritalStatuses,
  [GET_IS_FETCHING_MARITAL_STATUSES]: state => state.isFetchingMaritalStatuses,
  [GET_LOCATION_GROUPINGS]: state => state.locationGroupings,
  [GET_ETHNIC_GROUPS]: state => state.ethnicGroups,
  [GET_GRADES]: state => state.grades,
  [GET_WORKING_HOURS]: state => state.workingHours,
  [GET_WORKING_HOURS_GROUPINGS]: state => state.workingHoursGroupings,
  [GET_IS_FETCHING_GRADES]: state => state.isFetchingGrades,
  [GET_IS_FETCHING_WORKING_HOURS]: state => state.isFetchingWorkingHours,
  [GET_IS_FETCHING_WORKING_HOURS_GROUPINGS]: state =>
    state.isFetchingWorkingHoursGroupings,
  [GET_FUNCTIONS]: state => state.functions,
  [GET_IS_FETCHING_FUNCTIONS]: state => state.isFetchingFunctions,
  [GET_CONTRACT_TYPES]: state => state.contractTypes,
  [GET_IS_FETCHING_CONTRACT_TYPES]: state => state.isFetchingContractTypes,
  [GET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS]: state =>
    state.isFetchingContractTypesGroupings,
  [GET_CONTRACT_TYPES_GROUPINGS]: state => state.contractTypesGroupings
};

export default bookingsGetters;
